<div class="break-word suggestions-container">
    <span translate>I have some good answers you might want to use:</span>
    <ul class="list-unstyled suggestions-list light-text">
        @for (suggestion of suggestions; track suggestion) {
            <li class="d-flex align-items-center">
                <sb-inline-svg
                    class="icon me-1"
                    aria-label="My icon"
                    [url]="'/sb-tools/theme/images/icons/Normal Icon - Light bulb.svg'">
                </sb-inline-svg>
                <div class="suggestion-text" [ngClass]="{ pointer: suggestion.text.length > 36 }">
                    <app-read-more [text]="suggestion.text" [maxLength]="36"></app-read-more>
                </div>
                <button (click)="parent.chooseSuggestion(suggestion)">
                    <sb-inline-svg
                        class="icon"
                        aria-label="My icon"
                        [url]="'/sb-tools/theme/images/icons/Normal Icon - Plus.svg'">
                    </sb-inline-svg>
                </button>
                <app-score-bar [score]="suggestion.score"></app-score-bar>
            </li>
        }
    </ul>
</div>
